import {
  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FOLLOW_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FOLLOW_TRIBUN_USER_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case FOLLOW_TRIBUN_USER_FAILURE:
      return { ... state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};